<template lang="pug">
    .time-range
        h2 Extend time
        p Set up the marker to change time
        .rect-list
            .slider
                i(class="fa fa-circle fa-2x", aria-hidden="true")
            .rect(v-for="(item, index) in availability", :class="{available: item.available, reservation: isInReservation(index)}", @click="onClick(index)")
                .text(v-if="index % 3 == 0") {{ formatDate(item.end) }}
        h3(v-if="debug.selectedEnd") Extend this reservation to {{ debug.selectedEnd }}
        .button(@click="handleConfirm") Confirm Extension
</template>
<script type="text/babel">
  import moment from 'moment'

  export default {
    name: "TimeRange",
    components: {},
    props: ['reservation','availability'],
    data() {
      return {
        selectedEndTimestamp: null,
        debug: {
          selectedBox: null,
          selectedEnd: null
        },
      }
    },
    created() {
    },
    mounted() {

      var self = this
      this.getSlider().draggable({
        grid: [20, 20],
        containment: "parent",
        zIndex: 99,
        axis: "x",
        stop: function () {
          self.onEdit()
        },
        drag: function () {
          self.onEdit()
        },
      });

      this.getSlider().bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
        self.onEdit()
      });

    },
    destroyed() {
      this.getSlider().draggable("destroy");
    },
    methods: {
      getSlider: function () {
        return $(this.$el).find(".slider")
      },
      onEdit: function () {
        var currentSlot = Math.floor(this.getSlider().position().left / 20)

        if (currentSlot != this.debug.selectedBox) {
          this.debug.selectedBox = currentSlot
          this.debug.selectedEnd = this.availability[this.debug.selectedBox].end
          this.selectedEndTimestamp = this.availability[this.debug.selectedBox].end_timestamp
        }
      },
      onClick: function (index) {
        var value = (index) * 20
        this.getSlider().css('left', value + 'px');
      },
      isInReservation: function (index) {
        var item = this.availability[index]
        var reservation = this.reservation

        // TODO: refactor this
        return item.start_timestamp >= this.convertTimestamp(reservation.start) && item.end_timestamp <= this.convertTimestamp(reservation.end) + 60
      },
      formatDate: function (date) {
        var i = moment(date)
        return i.format("HH:mm")
      },
      handleConfirm: function () {
        this.$emit('selection',this.debug.selectedEnd)
      },
      convertTimestamp: function (datetime) {
        var t = datetime.split(/[- :]/);
        var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4]);
        return Math.round(date.getTime() / 1000);
      },
    },
    computed: {}
  }
</script>
<style lang="sass">

</style>



// WEBPACK FOOTER //
// TimeRange.vue?1c75b4dd